import {CSSProperties} from "react";
import styled from "styled-components";
import {isValidString} from "../../utils";
interface FlexProps {
    justify?: CSSProperties['justifyContent'],
    align?: CSSProperties['alignItems'],
}

export const FlexRow = styled.div`
  display: flex;
  justify-content: ${(props: FlexProps) => props.hasOwnProperty('justify') && isValidString(props.justify) ? props.justify : 'flex-start'};
  align-items: ${(props: FlexProps) => props.hasOwnProperty('align') && isValidString(props.align) ? props.align : 'normal'};
`;
